<div class="flex gap-5">
  <div class="w-14 text-sm text-font-primary text-[0.8125rem] leading-[1.125rem]">{{ limitItem.label }}</div>

  @if (limitItem.limitType === 'SINGLE') {
    <div class="font-extrabold text-secondary text-[0.8125rem] leading-[1.125rem] mb-2">
      {{ limitItem.currency | currencySign }}
      {{ (limitItem.amount | number: '1.2-2') || '' | mask: 'separator' : { thousandSeparator: ',' } }}
    </div>
  } @else {
    <div class="flex-1 flex flex-col gap-1">
      <div class="h-2 rounded-full bg-[#F7F7F7] w-full relative overflow-hidden">
        <div class="bg-secondary h-2 left-0 top-0" [ngStyle]="{ width: limitItem.progress > 100 ? 100 : limitItem.progress + '%' }"></div>
      </div>

      <div class="flex justify-between gap-5 font-semibold text-font-secondary text-xs">
        <div>
          <span class="text-secondary">
            {{ limitItem.currency | currencySign }}
            {{ (limitItem.used | number: '1.2-2') || '' | mask: 'separator' : { thousandSeparator: ',' } }} spent
          </span>
          of {{ (limitItem.amount | number: '1.2-2') || '' | mask: 'separator' : { thousandSeparator: ',' } }}
        </div>
        <div class="text-secondary">
          @if (limitItem.progress > 0 && limitItem.progress < 1) {
            <span><1</span>
          } @else {
            {{ limitItem.progress | number: '1.0-1' }}
          }
          %
        </div>
      </div>
    </div>
  }
</div>
